// src/data/toolCategories.js
// Mirrors the sidebar panel grouping in Dashborad.js so the tools grid can be
// filtered by the same categories the user already knows from the sidebar.

export const TOOL_CATEGORIES = [
    'مدیریت',
    'مالی',
    'فروش',
    'الحاقیه',
    'گزارشات',
    'پشتیبانی',
    'فاکتورها',
    'سایر',
];
